import { Box, Flex, Image, Text, useBreakpointValue } from "@chakra-ui/react"
import { useState } from "react";
import { VdoCipherPlayer } from "@components/VdoCipherPlayer/vdo-cipher-player.tsx"
import MargazhiTestimonialsVideoPopup from "./MargazhiTestimonialsVideoPopup";
import { mixPanel } from '@utils/Mixpanel';


let MargazhiTestimonials = ({ section }) => {

    let [videoIndx, setVideoIndx] = useState(null)
    let videoData = useBreakpointValue({ base: section.sectionContent?.[5]?.data, md: section.sectionContent?.[4]?.data, xl: section.sectionContent?.[3]?.data})

    let [refresh, setRefresh] = useState(0)


    // 👇 one breakpoint value for all thumbnails
    let isMobile = useBreakpointValue({ base: true, md: false });
    let isTablet = useBreakpointValue({base: false, md: true, xl: false})
    let imgSectionKey = useBreakpointValue({base: 'mobileImages', md: 'tabletImages', xl: 'images'})
    let playIconMargin = useBreakpointValue({base: '0.5rem', md: '0.8rem'})

    const mixPanelTrigger = () => {
        const Mixpanel = mixPanel(window?.location.pathname);
        Mixpanel.track('margazhi_video_played', {
        video_name: "user experience",
        });
    };

    const getThumbnailHeight = (aspectRatio) => {
        if (isMobile) {
            // return aspectRatio === "wider" ? "115px" : "131px";
            return 'auto'
        } else if (isTablet) {
            return "180px";
        } else {
            return aspectRatio === "wider" ? "223px" : "223px";
        }
    };

    let testThumPlayIconSize = useBreakpointValue({base: '28px', md: "34.72px", xl: '42.9px'})

    return <>
        <Flex bgColor={'#F8F1E7'} justifyContent={'center'} alignItems={'center'}
            py={{ base: '99.5px', md: "120px", lg: '160px' }}
        >
            <MargazhiTestimonialsVideoPopup
                videoData={videoData}
                videoIndx={videoIndx}
                setVideoIndx={setVideoIndx}
                setRefresh={setRefresh}
            />
            <Box maxWidth={{ base: '100%', md: '1202px' }} px="16px">
                <Text
                    fontFamily={'FedraSansStd-book'}
                    fontSize={{ base: '20px', md: '32px' }}
                    color={'#28231E'}
                    fontWeight={'400'}
                    letterSpacing={{ base: '3px', md: '4px' }}
                    // mb={{ base: '-0.9rem', md: '-1.5rem' }}
                    textTransform={'uppercase'}>{section?.sectionContent?.[0]?.text}</Text>
                <Text
                    color="#2F2F2F"
                    fontFamily="FedraSerifDisplayRegular"
                    fontSize={{ base: '56px', md: '72px', lg: '72px' }}
                    lineHeight={{ base: '56px', md: '72px', lg: '72px' }}
                    letterSpacing={{ base: '-1.12px', md: '-1.44px', lg: '-1.44px' }}
                    fontWeight="400"
                    mb={{ base: '32px', md: '32px' }}
                >{section?.sectionContent?.[1]?.text}</Text>
                <Flex flexWrap={'wrap'} 
                gap={'15px'}
                 flexDir={'row'} justifyContent={'center'}>
                    {section?.sectionContent?.[2]?.[imgSectionKey]?.map((i, j) => {
                        const thumbHeight = getThumbnailHeight(videoData?.[j]?.aspectRatio);
                        return <Box
                            width={{
                                base: videoData?.[j]?.aspectRatio === 'wider'? 'calc(100vw / 2.3)' : 'calc(100vw / 3.6)',
                                // base: videoData?.[j]?.aspectRatio === 'wider' ? '154px' : '99px',
                                md: videoData?.[j]?.aspectRatio === 'wider' ? '241px' : '136px',
                                lg: videoData?.[j]?.aspectRatio === 'wider' ? '298px' : '168px',
                            }}
                            height={thumbHeight}
                            onClick={() => {
                                if (videoData[j]?.videoId) {
                                    mixPanelTrigger()
                                    setVideoIndx(j)
                                }
                            }}
                            display={'flex'} alignItems={'center'} justifyContent={'center'}
                            cursor={videoData[j]?.videoId ? 'pointer' : 'unset'}
                            borderRadius={"4px"}
                            overflow={"hidden"}
                            key={j}
                        >
                            {videoData[j]?.bgVideoId && videoData[j]?.autoPlayBgVideo ?
                                <VdoCipherPlayer
                                    id={`${j}${new Date().getTime()}`}
                                    videoId={videoData?.[j]?.bgVideoId}
                                    startVideo={true}
                                    muteStatus={true}
                                    hideFullScreen={true}
                                    hideSoundIcon={true}
                                    hideDragProgBar={true}
                                    hidePlayPauseIcon={true}
                                    aspectRatio={videoData?.[j]?.aspectRatio === 'wider' ? '16/9' : '9/16'}
                                    iframeHeight={`height: ${thumbHeight}; transform: scale(1.7); `}
                                    onClick={() => {
                                        if (videoData[j]?.videoId) {
                                            mixPanelTrigger()
                                            setVideoIndx(j)
                                        }
                                    }}
                                    loopVideo={true}
                                    wrapperOverFlowHidden={true}
                                    showVideoInFullSize
                                />
                                : <Box position={'relative'}
                                width={{
                                    base: videoData?.[j]?.aspectRatio === 'wider'? 'calc(100vw / 2.3)' : 'calc(100vw / 3.6)',
                                    // base: videoData?.[j]?.aspectRatio === 'wider' ? '154px' : '99px',
                                    md: videoData?.[j]?.aspectRatio === 'wider' ? '241px' : '136px',
                                    lg: videoData?.[j]?.aspectRatio === 'wider' ? '298px' : '168px',
                                }}
                                height={thumbHeight}
                                > <Image
                                    width={'100%'} height={'100%'}
                                    src={i.url}
                                    display={'flex'}
                                />
                                    <svg style={{ position: 'absolute', bottom: playIconMargin, left: playIconMargin, width: testThumPlayIconSize, height: testThumPlayIconSize }}
                                        width="44" height="43" viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.617188" y="0.0273438" width="42.9597" height="42.9597" rx="21.4798" fill="#1D1A16" fill-opacity="0.6" />
                                        <path d="M16.895 13.2322C16.7662 13.1558 16.6063 13.1543 16.4762 13.2284C16.346 13.3025 16.2656 13.4407 16.2656 13.5905V29.4238C16.2656 29.5736 16.346 29.7118 16.4762 29.7859C16.6063 29.86 16.7662 29.8586 16.895 29.7821L30.2284 21.8654C30.3548 21.7904 30.4323 21.6542 30.4323 21.5072C30.4323 21.3601 30.3548 21.224 30.2284 21.1489L16.895 13.2322Z" fill="#F8F1E7" />
                                    </svg>
                                </Box>
                                }
                        </Box>
                    })}
                </Flex>
            </Box>
            <style jsx global>{`
                .allSmallCase {
                    font-variant: all-small-caps;
                }
            `}</style>
        </Flex>
    </>
}

export default MargazhiTestimonials;